/**
 * Star Harvest — Sol's unlock (MINIGAME_PROPOSALS O11). The scope wrote the
 * rationale: "We have to take their power supply away and harness it for our
 * own advantage." Launch collector satellites on long idle timers with
 * exponentially growing Alloy + Components costs; each adds +2 percent to
 * MECH CORE POWER OUTPUT. At 50 the swarm completes and reveals Reboot, the
 * post-launch nested-prestige layer.
 *
 * Design call: the one deliberately BIG multiplier (up to +100 percent Core
 * power), safe precisely because it is the last thing in the game.
 */

/** The swarm is complete at this many satellites. */
export const SWARM_COMPLETE = 50;

/** Core power output bonus per satellite (50 × 2% = the +100% victory lap). */
export const CORE_BOOST_PER_SAT = 0.02;

/** Launch timer: base × growth^n (long, idle, endgame). */
export const LAUNCH_BASE_MS = 45 * 60_000;
export const LAUNCH_GROWTH = 1.07;

/** Alloy cost: base × growth^n (flat economy; the Smelter feeds this). */
export const SAT_ALLOY_BASE = 40;
export const SAT_ALLOY_GROWTH = 1.07;

/** Components cost: base × growth^n × the frontier anchor (1.08^wave). */
export const SAT_COMP_BASE = 25;
export const SAT_COMP_GROWTH = 1.12;

export function launchDurationMs(satellites: number): number {
  return Math.round(LAUNCH_BASE_MS * Math.pow(LAUNCH_GROWTH, satellites));
}
